export default __webpack_public_path__ + "static/media/react-native.53c49082.jpg";